const features = [
  {
    icon: 'ri-shield-check-line',
    title: '安全访问保障',
    desc: '全站HTTPS加密传输，多重防护保障用户隐私与访问安全，安心观影无后顾之忧。',
  },
  {
    icon: 'ri-speed-up-line',
    title: '极速播放体验',
    desc: '多线路CDN智能加速，自适应码率切换技术，99.9%影片实现零缓冲流畅播放。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝同步',
    desc: '支持PC、手机、平板及智能电视投屏，观影记录云端同步，随时随地继续观看。',
  },
  {
    icon: 'ri-database-2-line',
    title: '海量正版资源',
    desc: '汇聚超过10,000部影视作品，涵盖电影、剧集、综艺、动漫等多种内容类型。',
  },
  {
    icon: 'ri-timer-flash-line',
    title: '每日实时更新',
    desc: '编辑团队7×24小时值守，每日更新50+部新内容，热门大片院线下映一周内上线。',
  },
];

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 mx-auto max-w-[1440px]">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 text-xs font-medium text-secondary-700 bg-secondary-100 rounded-full mb-3">
            为什么选择我们
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            平台特色
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-xl mx-auto">
            90影视持续优化的核心能力，为您带来更优质的在线观影体验
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {features.map((f, i) => (
            <div key={i} className="group bg-background-50 rounded-xl border border-background-200/60 p-5 md:p-6 hover:border-accent-300/50 transition-all duration-300 text-center">
              <div className="w-12 h-12 mx-auto flex items-center justify-center rounded-xl bg-accent-100 group-hover:bg-accent-200 transition-colors mb-4">
                <i className={`${f.icon} text-xl text-accent-600`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">{f.title}</h3>
              <p className="text-xs md:text-sm text-foreground-500 leading-relaxed">{f.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}